import React, { Component } from "react";
import { Row, Col } from "react-bootstrap";
import { Form, Radio, RadioGroup } from "informed";
import { validateProperty } from "../../components/Validation/JoiValidation";
import { DatePicker } from "../../components/forms/DatePicker";
import ImageUpload from "../../components/forms/ImageUpload/ImageUpload";
import { FaUserEdit } from "react-icons/fa";
import { subDirectory } from "../../config.json";
import { AddNotification } from "../../components/Methods/Notificaition";
import { TextInput } from "../../components/forms";
import "../../styles/Profile.scss";
import NavBar from "../common/forms/NavbarCopy";
import { getLocalStorageValues } from "../../services/boat";
import { setLocalStorevalue } from "../../services/authService";
import { getUserPublicProfile, updateUserPublicProfile, updatePublicImageUpload } from "../../services/PublicProfile";
import { IoIosAddCircleOutline } from "react-icons/io";

export default class BoatPublicProfile extends Component {
  state = {
    UserDetails: {},
    ImageLink: "",
    LastNameShow:false,
    Address2Show:false,
    ShowMore:false
    
  };
  setFormApi = (formApi) => (this.formApi = formApi);

  componentDidMount = async () => {
    await this.getUserDetails();
  };

  getUserDetails = async () => {
    let data = {
      QueryType: "Public",
      UserId: localStorage.getItem("UserId"),
      // "UserId":"500020"
    };

    const res = await getUserPublicProfile(data);

    if (res.data.StatusCode === 1) {
      if (res.data.Response.length > 0) {
        this.setState({ UserDetails: res.data.Response[0] });

        this.setState({ ImageLink: this.state.UserDetails.Photo });
      }
    } else {
      this.setState({ UserDetails: {} });
    }

    await this.formApi.setValues(this.state.UserDetails);
    // await this.formApi.setValue("DOB", "2021-10-12");
    console.log(this.state.UserDetails);

    if (this.state.UserDetails?.DOB) {
      let dob = this.state.UserDetails.DOB.split("/");
      console.log(this.state.UserDetails, dob);

      if (dob.length == 3) {
        let DOB = dob[2] + "-" + dob[1] + "-" + dob[0];
        console.log(DOB);
        await this.formApi.setValue("DOB", DOB);
      }
    }
  };

  pinCodeChange = async (e) => {
    if (e.target.value.length < 6) {
      return false;
    }
    await this.getPincodeValues(e.target.value);
  };

  getPincodeValues = async (pinCode) => {
    let response = "";
    await fetch(`https://api.postalpincode.in/pincode/${pinCode}`)
      .then((res) => res.text())
      .then((text) => (response = JSON.parse(text)));

    if (response[0]["Status"] === "Success") {
      await this.setState({ isPincode: true });

      this.formApi.setValues({
        City: response[0]["PostOffice"][0]["Block"],
        District: response[0]["PostOffice"][0]["District"],
        State: response[0]["PostOffice"][0]["State"],
        Country: response[0]["PostOffice"][0]["Country"],
      });


    } else {
      await this.setState({ isPincode: false });
      this.formApi.setValues({
        City: null,
        District: null,
        State: null,
      });
    }
  };

  getImageLink = async (file) => {
    const {
      data: { Response, StatusCode },
    } = await updatePublicImageUpload(file);

    if (StatusCode) return Response;
  };

  updateUserDetails = async () => {
    const values = this.formApi.getValues();

    if (this.state.FileName) {
      values.Photo = await this.getImageLink(this.state.FileName);
    } else {
      values.Photo = this.state.ImageLink;
    }
    delete values.GuestKYCLink;
    values["Aadhaar"] = "";
    const ReqData = {
      QueryType: "Public",
      UserId: getLocalStorageValues("UserId"),
      DOM: values.DOB,
      EmpDOJ: "",
      PromoNotification: "N",
      ...values,
    };

    const {
      data: { Response, StatusCode },
    } = await updateUserPublicProfile(ReqData);

    this.setState({
      loading: false,
      variant: "info",
      openNotification: true,
      message: Response,
    });
    await setLocalStorevalue("EmailId", values.EmailId);
    await this.getUserDetails();
  };

  reload = () => {
    this.props.history.push({
      pathname: `${subDirectory}/boat`,
    });
  };
  onSubmit = async (values) => {
    this.updateUserDetails();
  };


  onShowLastName = async () =>{
    this.setState({ LastNameShow: !this.state.LastNameShow });
    
  }

  onShowAddress2 = async () =>{
    this.setState({ Address2Show: !this.state.Address2Show });
    
  }

  onShowMore = async () =>{
    this.setState({ ShowMore: !this.state.ShowMore });
    
  }
  
  render() {
    const { UserDetails } = this.state;

    return (
      <div className="public-boat-profile">
        <>
          <NavBar {...this.props} />
          <div className="pbprofile">
            <AddNotification visible={this.state.openNotification} variant={this.state.variant} message={this.state.message} onClose={() => this.setState({ openNotification: false })} />
            <div className="profile-row">
              <div>
                <h4>User Profile</h4>
                <hr />
              </div>
            </div>
            <Form getApi={this.setFormApi} onSubmit={this.onSubmit} initialValues={{}}>
              {({ formApi, formState }) => (
                <>
                  <div className="row profile-container">
                    <div className="col-sm-2 pr-0 profile-image-container">
                      <ImageUpload
                        faClass="fas fa-image mr-2"
                        className=" form-control-sm textfieldstyle uploadbtn"
                        onChange={async (e) => {
                          await this.setState({
                            FileName: e.target.files[0],
                          });
                        }}
                        ImageLink={this.state.ImageLink ? this.state.ImageLink : ""}
                        field="GuestKYCLink"
                        label="Edit Profile Image"
                      />
                    </div>

                    <div className="col-sm-10 pl-0 profile-form-container">
                      <div className="col-sm-12 p-0 userInfo">
                        <div className="row p-0 mt-2">
                          <div className="col-sm-8 offset-sm-2 form-child">
                            <div className="child-form-2">
                              <Col md={6}>
                              <div style={{ display: 'flex', alignItems: 'center' }}>
                                <TextInput field="FirstName" label={this.state.LastNameShow ? "First Name" : "Name"} validateOnBlur validate={(e) => validateProperty(true, "name", e, "First Name")} />
                                <IoIosAddCircleOutline style={{ marginLeft: '10px', marginTop: '10px', cursor:"pointer",color:"green" }} size={20} onClick={() => this.onShowLastName()}/>
                              </div>
                                {/* <TextInput field="FirstName" label="First Name" validateOnBlur validate={(e) => validateProperty(true, "name", e, "First Name")} />  <IoIosAddCircleOutline /> */}
                              </Col>
                              {/* <Col md={6}>
                                <TextInput
                                  field="MiddleName"
                                  label="Middle Name"
                                  
                                />
                              </Col> */}
                             
                              <Col md={6} style={{display:!this.state.LastNameShow ? "none" :"flex"}}>
                                <TextInput field="LastName" label="Last Name" validateOnBlur validate={(e) => validateProperty(false, "name", e, "Last Name")}/>
                              </Col>
                              <Col md={6}>
                                <TextInput field="MobileNo" label="Mobile Number" validateOnBlur validate={(e) => validateProperty(true, "contact", e, "Mobile Number")} />
                              </Col>
                              
                              <Col md={6}>
                                <TextInput field="EmailId" label="Email Id" validateOnBlur validate={(e) => validateProperty(true, "email", e, "Email Id")} />
                              </Col>
                              

                              

                              {/* <Col md={6}>
                                <TextInput field="Aadhaar" label="Aadhar Id" validateOnBlur validate={(e) => validateProperty(false, "Aadharno", e, "Adhar Id")} />
                              </Col> */}
                              
                              <Col md={6}>
                                <TextInput field="ZipCode" label="Pincode / Zipcode" onChange={this.pinCodeChange} validateOnBlur validate={(e) => validateProperty(true, "postalCode", e, "Zipcode")} />
                              </Col>
                              <Col md={6}>
                                <TextInput field="City" label="City" disabled={true} />
                              </Col>
                              <Col md={6}>
                                <TextInput field="District" label="District" disabled={true} />
                              </Col>
                              <Col md={6}>
                                <TextInput field="State" label="State" disabled={true} />
                              </Col>
                              <Col md={6}>
                                <TextInput field="Country" label="Country" disabled={true} />
                              </Col>
                              <Col md={6} style={{display:this.formApi?.getValue("ZipCode")?.length < 6 ? "none" :"flex"}}>
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                

                                <TextInput
                                    field="Address1"
                                    label={this.state.Address2Show ? "Address 1" : "Address"}
                                    
                                  />
                                  <IoIosAddCircleOutline style={{ marginLeft: '10px', marginTop: '10px', cursor:"pointer",color:"green" }} size={20} onClick={() => this.onShowAddress2()}/>
                                  
                                </div>
                                
                                
                              </Col>
                              <Col md={6} style={{display:!this.state.Address2Show ? "none" :"flex"}}>
                                <TextInput
                                  field="Address2"
                                  label="Address 2"
                                  
                                />
                              </Col>
                              
                              
                            </div>
                            <div style={{color:"#1292EE",textDecoration:"underline"}} onClick={() => this.onShowMore()}>
                              More Details
                            </div>
                            <div className="child-form-2">
                            <Col md={6} style={{display:!this.state.ShowMore ? "none" :"flex"}}>
                                <DatePicker
                                  field="DOB"
                                  label="Date of Birth"
                                  onChange={(e) => {
                                    console.log(e.target.value);
                                  }}
                                  canSelectPast
                                  
                                />
                              </Col>
                              <Col md={6} className="my-2" style={{display:!this.state.ShowMore ? "none" :"flex"}}>
                                <div className="form-group">
                                  <label className="d-block">Gender</label>
                                  <RadioGroup field={"Gender"}>
                                    <div class="form-check form-check-inline">
                                      <label className="form-check-label">
                                        <Radio className="form-check-input mr-2 rmar" value="M" />
                                        Male
                                      </label>
                                    </div>
                                    <div class="form-check form-check-inline">
                                      <label className="form-check-label">
                                        <Radio className="form-check-input mr-2 rmar" value="F" />
                                        Female
                                      </label>
                                    </div>
                                  </RadioGroup>
                                </div>
                              </Col>
                              <Col md={6} className="my-2" style={{display:!this.state.ShowMore ? "none" :"flex"}}>
                                <div className="form-group">
                                  <label className="d-block">MaritalStatus</label>
                                  <RadioGroup field={"MaritalStatus"}>
                                    <div class="form-check form-check-inline">
                                      <label className="form-check-label">
                                        <Radio className="form-check-input mr-2 rmar" value="N" />
                                        Single
                                      </label>
                                    </div>
                                    <div class="form-check form-check-inline">
                                      <label className="form-check-label">
                                        <Radio className="form-check-input mr-2 rmar" value="Y" />
                                        Married
                                      </label>
                                    </div>
                                  </RadioGroup>
                                </div>
                              </Col>
                            </div>
                            <div className="update-btn-profile">
                              <button type="submit" className="btn btn-info mr-3" style={{ backgroundColor: "#28a745", border: "none", color: "white", fontWeight: "600" }}>
                                Update
                              </button>
                              <button style={{ backgroundColor: "#545b62", border: "none", color: "white", fontWeight: "600" }} type="button" className="btn" onClick={() => window.location.replace(`${subDirectory}`)}>
                                Cancel
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              )}
            </Form>
          </div>
        </>
      </div>
    );
  }
}
